export default __webpack_public_path__ + "./images/kh.229f9023.png";